import { useState, useEffect } from "react";

const BASE = "https://support.gs-group.fr/api";

export default function KmReminderPublic({ token }) {
  const [data, setData]       = useState(null);
  const [error, setError]     = useState("");
  const [step, setStep]       = useState("loading"); // loading | ready | saved | error
  const [km, setKm]           = useState("");
  const [kmErr, setKmErr]     = useState("");
  const [saving, setSaving]   = useState(false);

  useEffect(() => {
    fetch(`${BASE}/km/${token}`)
      .then(r => r.json())
      .then(d => {
        if (d.error) { setError(d.error); setStep("error"); return; }
        setData(d);
        setStep("ready");
      })
      .catch(() => { setError("Impossible de charger le véhicule."); setStep("error"); });
  }, [token]);

  const handleSave = async () => {
    const n = parseInt(km, 10);
    if (!Number.isFinite(n) || n <= 0) { setKmErr("Merci de saisir un kilométrage valide."); return; }
    if (data?.kilometrage_actuel && n < data.kilometrage_actuel) {
      setKmErr(`Le kilométrage ne peut pas être inférieur au dernier relevé (${data.kilometrage_actuel.toLocaleString("fr-FR")} km).`);
      return;
    }
    setKmErr(""); setSaving(true);
    try {
      const r = await fetch(`${BASE}/km/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ kilometrage: n }),
      });
      const res = await r.json();
      if (res.ok) setStep("saved");
      else setError(res.error || "Erreur");
    } catch { setError("Erreur réseau"); }
    setSaving(false);
  };

  if (step === "loading") return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"#f0f9ff" }}>
      <div style={{ textAlign:"center", color:"#0369a1" }}>
        <div style={{ fontSize:40, marginBottom:12 }}>🚗</div>
        <div style={{ fontSize:16, fontWeight:600 }}>Chargement…</div>
      </div>
    </div>
  );

  if (step === "error") return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"#fff1f2" }}>
      <div style={{ textAlign:"center", maxWidth:400, padding:32 }}>
        <div style={{ fontSize:48, marginBottom:16 }}>⛔</div>
        <div style={{ fontSize:18, fontWeight:700, color:"#991b1b", marginBottom:8 }}>Lien invalide</div>
        <div style={{ fontSize:14, color:"#6b7280" }}>{error}</div>
      </div>
    </div>
  );

  if (step === "saved") return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"#f0fdf4" }}>
      <div style={{ textAlign:"center", maxWidth:440, padding:32 }}>
        <div style={{ fontSize:60, marginBottom:16 }}>✅</div>
        <div style={{ fontSize:22, fontWeight:900, color:"#065f46", marginBottom:10 }}>Kilométrage enregistré !</div>
        <div style={{ fontSize:14, color:"#64748b", lineHeight:1.7 }}>
          Merci, le relevé a bien été pris en compte pour <strong>{data?.immatriculation}</strong>.
        </div>
      </div>
    </div>
  );

  // step === "ready"
  return (
    <div style={{ minHeight:"100vh", background:"#f8fafc", display:"flex", flexDirection:"column" }}>
      <div style={{ background:"linear-gradient(135deg,#0369a1,#0284c7)", padding:"24px 32px", color:"#fff" }}>
        <div style={{ maxWidth:480, margin:"0 auto", display:"flex", alignItems:"center", gap:16 }}>
          <div style={{ fontSize:36 }}>🚗</div>
          <div>
            <div style={{ fontSize:20, fontWeight:900 }}>GS GROUP — Relevé kilométrique</div>
            <div style={{ fontSize:13, opacity:.85, marginTop:2 }}>{data.marque} {data.modele} · {data.immatriculation}</div>
          </div>
        </div>
      </div>

      <div style={{ maxWidth:480, margin:"0 auto", padding:"32px 24px", width:"100%", flex:1 }}>
        <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:14, padding:"22px 24px", marginBottom:20, boxShadow:"0 1px 4px rgba(0,0,0,.06)" }}>
          <div style={{ fontSize:13, fontWeight:700, color:"#94a3b8", textTransform:"uppercase", letterSpacing:".5px", marginBottom:12 }}>Kilométrage actuel</div>
          <input
            type="number" inputMode="numeric" value={km}
            onChange={e => { setKm(e.target.value); setKmErr(""); }}
            placeholder={data.kilometrage_actuel ? `Dernier relevé : ${data.kilometrage_actuel.toLocaleString("fr-FR")} km` : "ex: 125000"}
            style={{ width:"100%", padding:"13px 14px", borderRadius:10, border:`1.5px solid ${kmErr?"#ef4444":"#e2e8f0"}`, fontSize:18, fontWeight:700, outline:"none", color:"#1e293b", background:"#f8fafc", boxSizing:"border-box" }}
          />
          {kmErr && <div style={{ fontSize:12, color:"#ef4444", marginTop:8 }}>⚠ {kmErr}</div>}
        </div>

        <button onClick={handleSave} disabled={saving || !km}
          style={{ width:"100%", padding:"14px", borderRadius:10, background:saving||!km?"#e2e8f0":"linear-gradient(135deg,#0369a1,#0284c7)", border:"none", color:saving||!km?"#94a3b8":"#fff", fontSize:15, fontWeight:700, cursor:saving||!km?"not-allowed":"pointer" }}>
          {saving?"Enregistrement…":"✅ Valider mon kilométrage"}
        </button>
      </div>
    </div>
  );
}
